import { DateField } from "components/DesignSystem/DateInput/DateField";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import { YYYY_MM_DD } from "constants/date";
import { AccountsType } from "constants/accountsType";
import dayjs from "dayjs";
import { object, string } from "yup";

interface EnableAccountsReceivableModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: ({ date }: { date: string }) => Promise<void>;
  isUpdating: boolean;
  type?: AccountsType;
}

const CONTENT_MAP = {
  receivable: {
    title: "Enable Auto-Manage Accounts Receivable?",
    dateLabel: "Accounts Receivable Start Date",
  },
  payable: {
    title: "Enable Auto-Manage Accounts Payable?",
    dateLabel: "Accounts Payable Start Date",
  },
} as const;

export const EnableAccountsReceivableModal = ({
  isOpen,
  onClose,
  onConfirm,
  isUpdating,
  type = "receivable",
}: EnableAccountsReceivableModalProps) => {
  const content = CONTENT_MAP[type];

  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content asChild useCustomOverlay>
        <FormikForm
          validationSchema={object({
            date: string().nullable().required("Date is required"),
          })}
          initialValues={{
            date: dayjs().format(YYYY_MM_DD),
          }}
          //  @ts-ignore
          onSubmit={onConfirm}
        >
          <Modal.Header>
            <Modal.Title>{content.title}</Modal.Title>
            <Modal.Close />
          </Modal.Header>
          <Modal.Body>
            <div className="t-flex t-flex-col t-gap-5">
              <DateField
                name="date"
                dateProps={{
                  required: true,
                  label: content.dateLabel,
                }}
              />
            </div>
          </Modal.Body>
          <Modal.FooterButtonGroup>
            <Button onClick={onClose} type="button">
              Cancel
            </Button>
            <Button
              customType="primary"
              isLoading={isUpdating}
              disabled={isUpdating}
            >
              Enable
            </Button>
          </Modal.FooterButtonGroup>
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
